const en = {
    'downgradeToProPlanModal.title': 'By downgrading to the Pro plan <red>you will only be able to keep one business</red>, please choose it:',
    'downgradeToProPlanModal.advice': 'Please note that this change will be effective immediately and the corresponding adjustment will be made to your billing.',
    'downgradeToProPlanModal.confirm': 'I confirm and accept to change to the Pro plan, and I am aware that this decision is irrevocable.',
    'downgradeToProPlanModal.buttons.downgrade': 'Downgrade to Pro plan',
    'downgradeToProPlanModal.buttons.cancel': 'Cancel'
}

export default en;